/**
 * 工作台
 */

import request from "@/service/request";

// 贵金属行情
export async function getNobleMetal() {
  return await request.get("/common/noble_metal/index");
}

// 时区列表
export async function getTimezone() {
  return await request.get("/common/timezone/index");
}

// 保存时区
export async function saveTimezone(params) {
  return await request.post("/common/timezone_log/save", {
    params,
  });
}

// 时区日志列表
export async function getTimezoneLog() {
  return await request.get("/common/timezone_log/index");
}

// 删除时区
export async function deleteTimezone(id) {
  return await request.put("/common/timezone_log/delete/" + id);
}

// 消息中心
export async function getNotice() {
  return await request.get("/common/notice/index");
}

// 消息状态
export async function getNoticeStatus() {
  return await request.get("/common/notice/status");
}